import formBaseMixin from '../../../components/form/form-base-mixin.js'
import {
  SENSOR_STATUS_ACTIVE,
  SENSOR_STATUS_ALARMED,
  SENSOR_STATUS_BROKEN,
  STATUS_NOT_ACTIVE
}                     from '../../../config/config.js'
import {msnOffline}   from '../../../api/api-offline-endpoints.js'
import {msn}          from '../../../api/api-endpoints.js'
import userFriendlyEr from "../../../utils/userFriendlyEr";
import year           from "../../../utils/year";
import {core}         from "../../../api/api-endpoints";
import documentsMixin from '@/common/layout/documents/documentsMixin'

export default {
  mixins: [formBaseMixin, documentsMixin],
  data () {
    return {
      fields: {
        _summaryContainersVolume: 0,
        close_date: '',
        msn_container_area_fence_id: '',
        msn_container_area_floor_id: '',
        msn_container_area_roof_id: '',
        msn_by_type_id: '',
        is_temporarily: false,
        wasteOut: {}
      }
    }
  },
  computed: {
    wasteout() {
      return this.$store.getters.readUrlEndpoint(this.getWasteoutEndpoint()).wasteout
    },
    notActive () {
      return STATUS_NOT_ACTIVE
    },
    collection () {
      return this.$store.getters.readUrlEndpoint(
        this.getCollectionEndpoint()
      ) || {}
    },
    sensorStatuses() {
      return this.collection.status_msn || []
    },
    statuses () {
      return this.collection.status || []
    },
    roofTypes () {
      return this.collection.msn_container_roof || []
    },
    fenceTypes () {
      return this.collection.msn_container_fence || []
    },
    underSurfaceTypes () {
      return this.collection.msn_container_floor || []
    },
    recyclableTypes () {
      return this.collection.recyclable_type || []
    },
    msnByTypes () {
      return this.collection.msn_by_type || []
    },
    isSeparateTypes () {
      return [
        {id: 0, name: 'Нет'},
        {id: 1, name: 'Да'}
      ]
    },
    containers () {
      if (this.$route.params.id && this.getContainersEndpoint) {
        return this.$store.getters.readUrlEndpoint(
          this.getContainersEndpoint(this.$route)
        )
      }
      return this.$store.getters.readUrlEndpoint(
        msnOffline.tkoContainersTable(this.$route.name)
      )
    },
    separateContainers () {
      if (this.$route.params.id && this.getContainersSeparateEndpoint) {
        return this.$store.getters.readUrlEndpoint(
          this.getContainersSeparateEndpoint(this.$route)
        )
      }
      return this.$store.getters.readUrlEndpoint(
        msnOffline.separateContainersTable(this.$route.name)
      )
    },
    // may repeat in /src/app/msn/components/container-table.vue
    // at calcVolumeSum
    containersVolumeSum () {
      let sum = 0
      if (this.containers && this.containers.data) {
        this.containers.data.forEach(v => {
          if (!isNaN(v.volume * v.count)) {
            sum = sum + (v.volume * v.count)
          }
        })
      }
      // yes = 1
      if (this.fields.is_separate && this.separateContainers && this.separateContainers.data) {
        this.separateContainers.data.forEach(v => {
          if (!isNaN(v.volume * v.count)) {
            sum = sum + (v.volume * v.count)
          }
        })
      }
      return sum
    },
    containersCount () {
      let sum = 0
      if (this.containers?.data?.length) {
        this.containers.data.forEach(v => {
          if (!isNaN(v.count)) {
            sum = sum + v.count
          }
        })
      }
      if (this.fields?.is_separate && this.separateContainers?.data?.length) {
        this.separateContainers.data.forEach(v => {
          if (!isNaN(v.count)) {
            sum = sum + v.count
          }
        })
      }
      return sum
    },
    wasteoutCalc() {
      let speed = 0
      if (this.fields.wasteoutLast && this.fields.wasteoutLast.avgFillingRate && !isNaN(this.fields.wasteoutLast.avgFillingRate)) {
        speed = (this.fields.wasteoutLast.avgFillingRate / 1000000).toFixed(1)
      }
      return {
        speed
      }
    }
  },
  watch: {
    'containersVolumeSum': {
      handler: 'onContainersVolumeSum',
      deep: true
    },
    'containersCount': {
      handler: 'onContainersCount',
      deep: true
    }
  },
  methods: {
    onWasteoutChange() {
      this.wasteout.forEach(v => {
        if (v.pointId == this.fields.wasteout_id) {
          this.$refs.location.setCoordinates([v.latitude, v.longitude])
          if (v.hasOwnProperty('status_msn_id')) {
            this.$set(this.fields, 'status_msn_id', v.status_msn_id)
          } else {
            if (v.broken) {
              this.$set(this.fields, 'status_msn_id', SENSOR_STATUS_BROKEN)
            } else if (v.alarmed) {
              this.$set(this.fields, 'status_msn_id', SENSOR_STATUS_ALARMED)
            } else if (v.active) {
              this.$set(this.fields, 'status_msn_id', SENSOR_STATUS_ACTIVE)
            }
          }
          this.$set(this.fields, 'wasteoutLast', v)
        }
      })
    },
    fileUploaded ({id}) {
      this.fields.photo_id = id
    },
    fileRemoved () {
      this.fields.photo_id = null
    },
    uploadUrl () {
      return core.file()
    },
    onContainersVolumeSum (val) {
      this.$set(this.fields, 'volume_count', val.toFixed(3))
    },
    onContainersCount(val) {
      this.$set(this.fields, 'containers_count', +val)
    },
    initFieldsAfterLoad() {
      if (this.item) {
        this.fields = Object.assign({}, this.fields, this.item)

        if (!this.fields?.wasteoutLast) {
          this.$set(this.fields, 'wasteoutLast', {})
        }

        if (this.fields.container_area) {
          this.fields.msn_container_area_fence_id = this.fields.container_area.msn_container_area_fence_id
          this.fields.msn_container_area_floor_id = this.fields.container_area.msn_container_area_floor_id
          this.fields.msn_container_area_roof_id = this.fields.container_area.msn_container_area_roof_id
        } else {
          this.fields.msn_container_area_fence_id = ''
          this.fields.msn_container_area_floor_id = ''
          this.fields.msn_container_area_roof_id = ''
        }

        this.fields.is_separate = +this.fields.is_separate
        this.fields.volume_count = this.containersVolumeSum.toFixed(3)
      }
    },
    getEditablesEndpointsAndUrl () {
      let postUrl = []
      let tmpEndpoints = []

      // add garbage
      let years = year.getYears()
      let operations = ['operation-detail', 'operation-detail-separate']
      for (let i = 0; i < years.length; i++) {
        for (let j = 0; j < operations.length; j++) {
          postUrl.push(msn.garbageOperationPost(this.fields.id, operations[j]))
          tmpEndpoints.push(msnOffline.garbageTable(this.$route.name, years[i], operations[j]))
        }
      }

      // add container table
      // non separate
      postUrl.push(msn.containersTableCreate(this.fields.id))
      tmpEndpoints.push(msnOffline.tkoContainersTable(this.$route.name))
      // separate
      postUrl.push(msn.containersTableCreate(this.fields.id))
      tmpEndpoints.push(msnOffline.separateContainersTable(this.$route.name))

      postUrl.push(msn.servicePost(this.fields.id))
      tmpEndpoints.push(msnOffline.serviceTable(this.$route.name))

      // house and garbage table
      // garbage
      postUrl.push(msn.garbageHouseOperationPost(this.fields.id, '1'))
      tmpEndpoints.push(msnOffline.garbageHouseContainerTable(this.$route.name, '1'))
      // house
      postUrl.push(msn.garbageHouseOperationPost(this.fields.id, '2'))
      tmpEndpoints.push(msnOffline.garbageHouseContainerTable(this.$route.name, '2'))

      return {postUrl: postUrl, tmpEndpoints: tmpEndpoints}
    },
    afterSave: async function () {
      let errors = []
      console.log(this.getEditablesEndpointsAndUrl())

      if (!this.$route.params.id) {
        let {postUrl, tmpEndpoints} = this.getEditablesEndpointsAndUrl()

        for (let i = 0; i < tmpEndpoints.length; i++) {
          if (this.$store.getters.readUrlEndpoint(tmpEndpoints[i])) {
            let data = this.$store.getters.readUrlEndpoint(tmpEndpoints[i]).data
            for (let j = 0; j < data.length; j++) {
              if (data[j]._isValid === true && data[j]._considerSaved === true) {
                try {
                  await this.$store.dispatch('createModel', {
                    url: postUrl[i],
                    endpoint: tmpEndpoints[i],
                    data: data[j]
                  })
                } catch (e) {
                  console.log(e)
                  errors.push(userFriendlyEr.recognize(e))
                }
              } else {
                console.warn('Invalid row', data[j])
              }
            }
          }
        }
      }

      if (errors.length > 0) {
        console.log(errors)
        return Promise.reject(errors.join('<br><br>'))
      }

      return Promise.resolve(1)
    }
  },
  asyncData ({store, route, fromRoute, methods}) {
    let promises = []
    if (methods.getItemEndpoint(route, fromRoute) !== null) {
      promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getItemEndpoint(route, fromRoute)}))
    }

    promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getCollectionEndpoint(), fromCache: true}))

    if (methods.getSurfaceEndpoint) {
      promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getSurfaceEndpoint(), fromCache: true}))
    }
    if (methods.getFenceEndpoint) {
      promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getFenceEndpoint(), fromCache: true}))
    }
    if (methods.getRoofEndpoint) {
      promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getRoofEndpoint(), fromCache: true}))
    }
    if (methods.getWasteoutEndpoint) {
      promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getWasteoutEndpoint()}))
    }
    // for calc summaery volume
    if (methods.getContainersEndpoint && methods.getContainersEndpoint(route)) {
      promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getContainersEndpoint(route)}))
    }
    if (methods.getContainersSeparateEndpoint && methods.getContainersSeparateEndpoint(route)) {
      promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getContainersSeparateEndpoint(route)}))
    }

    if (promises.length === 0) {
      return Promise.resolve(1)
    }

    return Promise.all(promises)
  }
}

